import React from 'react';
import PropTypes from 'prop-types';

/**
 * VideoEmbed component for displaying embedded videos
 * @param {Object} props Component props
 * @param {string} props.src Video embed URL
 * @param {string} props.title Video title for accessibility
 * @returns {React.ReactElement} VideoEmbed component
 */
const VideoEmbed = ({ src, title }) => {
  return (
    <div style={{ position: 'relative', paddingTop: '56.25%' }}>
      <iframe
        src={src}
        loading="lazy"
        style={{ border: 'none', position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowFullScreen={true}
        title={title}
      />
    </div>
  );
};

VideoEmbed.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default VideoEmbed;
